<template>
  <div class="tab-bar">
    <div v-for="item in visibleTabs" :key="item.key" class="tab-item" :class="{ active: activeKey === item.key }"
      @click="handleClick(item)">
      <img class="tab-icon" :src="activeKey === item.key ? item.activeIcon : item.icon" />
      <h6 :class="{ 'tab-text-active': activeKey === item.key }">
        {{ item.text }}
      </h6>
      <span class="message-badge" v-if="item.key === 'message' && unreadCount > 0">
        {{ unreadCount > 99 ? '99+' : unreadCount }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Notify } from "vant";

export default {
  name: "TabBar",
  props: {
    activeKey: {
      type: String,
      default: "home"
    }
  },
  data() {
    return {
      allTabs1: [
        {
          key: "home",
          text: "首页",
          icon: require("../assets/btn_home_n@2x.png"),
          activeIcon: require("../assets/btn_home_h@2x.png"),
          roles: [],
          path: "/homePage"
        },
        {
          key: "encounter",
          text: "遇见",
          icon: require("../assets/btn_activity_n@2x.png"),
          activeIcon: require("../assets/btn_activity_h@2x.png"),
          roles: ["GeneralUser", "Member"],
          path: "/encounter"
        },
        {
          key: "matchmaker",
          text: "红娘团队",
          icon: require("../assets/btn_Matchmaker_n@2x.png"),
          activeIcon: require("../assets/btn_Matchmaker_h@2x.png"),
          roles: ["Matchmaker", "Member"],
          path: "/matchmakerList"
        },
        {
          key: "activity",
          text: "活动中心",
          icon: require("../assets/btn_activity_n@2x.png"),
          activeIcon: require("../assets/btn_activity_h@2x.png"),
          roles: [],
          path: "/activity"
        },
        {
          key: "message",
          text: "消息",
          icon: require("../assets/btn_activity_n@2x.png"),
          activeIcon: require("../assets/btn_activity_h@2x.png"),
          roles: ["Matchmaker", "Member"],
          path: "/conversationList",
          needBadge: true
        },
        {
          key: "matchmakerCenter",
          text: "红娘中心",
          icon: require("../assets/btn_Matchmaker_n@2x.png"),
          activeIcon: require("../assets/btn_Matchmaker_h@2x.png"),
          roles: ["Matchmaker"],
          path: "/matchmakerCenter"
        },
        {
          key: "memberCenter",
          text: "会员中心",
          icon: require("../assets/btn_me_n@2x.png"),
          activeIcon: require("../assets/btn_me_h@2x.png"),
          roles: ["Member"],
          path: "/memberCenter"
        }
      ],
      allTabs2: [
        // {
        //   key: "home",
        //   text: "首页",
        //   icon: require("../assets/btn_home_n@2x.png"),
        //   activeIcon: require("../assets/btn_home_h@2x.png"),
        //   roles: [],
        //   path: "/homePage"
        // },
        {
          key: "encounter",
          text: "遇见",
          icon: require("../assets/btn_activity_n@2x.png"),
          activeIcon: require("../assets/btn_activity_h@2x.png"),
          roles: ["GeneralUser", "Member"],
          path: "/encounter"
        },
        {
          key: "matchmaker",
          text: "红娘团队",
          icon: require("../assets/btn_Matchmaker_n@2x.png"),
          activeIcon: require("../assets/btn_Matchmaker_h@2x.png"),
          roles: ["Matchmaker", "Member"],
          path: "/matchmakerList"
        },
        {
          key: "activity",
          text: "活动中心",
          icon: require("../assets/btn_activity_n@2x.png"),
          activeIcon: require("../assets/btn_activity_h@2x.png"),
          roles: [],
          path: "/activity"
        },
        {
          key: "message",
          text: "消息",
          icon: require("../assets/btn_activity_n@2x.png"),
          activeIcon: require("../assets/btn_activity_h@2x.png"),
          roles: ["Matchmaker", "Member"],
          path: "/conversationList",
          needBadge: true
        },
        {
          key: "matchmakerCenter",
          text: "红娘中心",
          icon: require("../assets/btn_Matchmaker_n@2x.png"),
          activeIcon: require("../assets/btn_Matchmaker_h@2x.png"),
          roles: ["Matchmaker"],
          path: "/matchmakerCenter"
        },
        {
          key: "memberCenter",
          text: "会员中心",
          icon: require("../assets/btn_me_n@2x.png"),
          activeIcon: require("../assets/btn_me_h@2x.png"),
          roles: ["Member"],
          path: "/memberCenter"
        }
      ],
      allTabs3: [
        {
          key: "matchmakerCenter",
          text: "红娘中心",
          icon: require("../assets/btn_Matchmaker_n@2x.png"),
          activeIcon: require("../assets/btn_Matchmaker_h@2x.png"),
          roles: ["Matchmaker"],
          path: "/matchmakerCenter"
        },
        {
          key: "encounter",
          text: "遇见",
          icon: require("../assets/btn_activity_n@2x.png"),
          activeIcon: require("../assets/btn_activity_h@2x.png"),
          roles: ["GeneralUser", "Member"],
          path: "/encounter"
        },
        {
          key: "activity",
          text: "活动中心",
          icon: require("../assets/btn_activity_n@2x.png"),
          activeIcon: require("../assets/btn_activity_h@2x.png"),
          roles: [],
          path: "/activity"
        },
        {
          key: "message",
          text: "消息",
          icon: require("../assets/btn_activity_n@2x.png"),
          activeIcon: require("../assets/btn_activity_h@2x.png"),
          roles: ["Matchmaker", "Member"],
          path: "/conversationList",
          needBadge: true
        },
        {
          key: "memberCenter",
          text: "会员中心",
          icon: require("../assets/btn_me_n@2x.png"),
          activeIcon: require("../assets/btn_me_h@2x.png"),
          roles: ["Member"],
          path: "/memberCenter"
        },
        {
          key: "matchmaker",
          text: "团队",
          icon: require("../assets/btn_Matchmaker_n@2x.png"),
          activeIcon: require("../assets/btn_Matchmaker_h@2x.png"),
          roles: ["Matchmaker", "Member"],
          path: "/matchmakerList"
        }
      ],
      pollingTimer: null
    };
  },
  computed: {
    ...mapGetters(["role", "unreadCount", "hasNewMessage", "latestMessage"]),
    visibleTabs() {
      var allTabs = this.allTabs1;
      switch (this.role) {
        case "Matchmaker":
          allTabs = this.allTabs3;
          break;
        case "Member":
          allTabs = this.allTabs2;
          break;
      }
      // allTabs = this.allTabs1;
      return allTabs.filter(tab => {
        if (tab.roles.length === 0) return true;
        return tab.roles.includes(this.role);
      });
    }
  },
  methods: {
    ...mapActions([
      "GetUnreadCount",
      "StartPolling",
      "StopPolling",
      "CheckNewMessages",
      "ClearNewMessageFlag"
    ]),
    handleClick(item) {
      if (this.activeKey === item.key) return;
      this.$router.push({ path: item.path });
      this.$emit("change", item.key);
    },
    startMessagePolling() {
      if (this.role === "Member" || this.role === "Matchmaker") {
        this.GetUnreadCount();
        this.StartPolling();
      }
    },
    async checkNewMessages() {
      try {
        await this.CheckNewMessages();
        if (this.hasNewMessage && this.latestMessage) {
          const message = this.latestMessage;
          let notifyMessage = "";
          if (this.role === "Member") {
            notifyMessage = `红娘[${message.latestSenderName}]给你发了一条消息`;
          } else {
            notifyMessage = "您收到一条新留言，对方正在等你回复，快去看看吧";
          }
          Notify({
            type: "primary",
            message: notifyMessage,
            duration: 5000,
            onClick: () => {
              this.$router.push({ path: "/conversationList" });
            }
          });
          this.ClearNewMessageFlag();
        }
      } catch (error) {
        console.error("检查新消息失败:", error);
      }
    }
  },
  mounted() {
    this.startMessagePolling();
  },
  beforeDestroy() {
    this.StopPolling();
  }
};
</script>

<style scoped lang="less">
@import url('../style/theme-variables.less');

.tab-bar {
  width: 100%;
  height: 3.2rem;
  padding: 0.25rem 0 calc(env(safe-area-inset-bottom, 0) + 0.15rem);
  background: rgba(245, 245, 247, 0.96);
  backdrop-filter: blur(16px);
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 100;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 -8px 24px rgba(26, 26, 26, 0.05);
}

.tab-item {
  flex: 1;
  height: 100%;
  text-align: center;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.tab-icon {
  width: 1.12rem;
  height: 1.12rem;
  filter: grayscale(50%);
  opacity: 0.62;
  transition: all 0.3s ease;
}

.tab-item h6 {
  width: 100%;
  min-height: 0.7rem;
  font-size: 0.5rem;
  font-family: @font-family-cn;
  font-weight: 500;
  color: @text-tertiary;
  line-height: 0.7rem;
  margin: 0.12rem 0 0 0;
  transition: all 0.3s ease;
}

.tab-text-active {
  color: @text-primary;
  font-weight: 600;
}

.tab-item.active {
  .tab-icon {
    filter: grayscale(0%);
    opacity: 1;
    transform: scale(1.08);
  }

  h6 {
    color: @text-primary;
  }
}

.tab-item.center-btn {
  .tab-icon {
    width: 2.4rem;
    height: 2.4rem;
    background: @gradient-primary;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -1.2rem;
    box-shadow: @shadow-center-btn;
    filter: none;
    opacity: 1;
    transform: scale(1);
  }

  h6 {
    position: absolute;
    bottom: 0;
    color: @primary-gradient-start;
    font-weight: 600;
  }
}

.message-badge {
  position: absolute;
  top: 0.38rem;
  right: calc(50% - 0.92rem);
  min-width: 0.8rem;
  height: 0.8rem;
  padding: 0 0.06rem;
  background-color: @error-color;
  border-radius: 1rem;
  font-size: 0.40rem;
  color: @text-light;
  line-height: 0.8rem;
  text-align: center;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/TabBar.vue